import { Moment } from 'moment'
import { create } from 'zustand'

export interface PrivatePlacement {
  state: string,
  issuer: string,
  issue: string,
  finalMaturity: Moment, 
  parAmount: number, 
  datedDate: Moment, 
  proxyPricingDate: string, 
  type: string,
  taxDesignation: string,
  securityCode: string,
  proxyRating: string,
  proxyAvgLife: string,
  coupon: number, 
  purchaser: string,
  advisor: string,
  bondConsel: string,
  sourceFile: string,
  ratingNote: string, 
  forward: string, 
  draw: string,
  callDate: Moment,
  postDate: Moment,
}

interface PrivatePlacementStore {
  loading: boolean,
  setLoading: (loading: boolean) => void,

  placements: PrivatePlacement[],
  setPlacements: (placements: PrivatePlacement[]) => void,
}

const usePrivatePlacementStore = create<PrivatePlacementStore>((set) => ({
  loading: false,
  setLoading: (loading: boolean) => set({ loading }),

  placements: [],
  setPlacements: (placements: PrivatePlacement[]) => set({ placements }),
}));

export default usePrivatePlacementStore;